export const geolocationMixin = {
  methods: {
    /**
     * Resolves the current device location and calls `callback(lat, long)`.
     * Falls back to "unknown" if geolocation is unavailable or denied.
     *
     * @param {(lat: number | string, long: number | string) => void} callback
     */
    getLocationAndCall(callback) {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            callback(position.coords.latitude, position.coords.longitude);
          },
          () => {
            callback("unknown", "unknown");
          },
        );
      } else {
        callback("unknown", "unknown");
      }
    },
  },
};
